"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var filesize = require("filesize");
var __1 = require("../../../");
var element_1 = require("../../../element");
var base_1 = require("./base");
var TickRenderer = /** @class */ (function (_super) {
    __extends(TickRenderer, _super);
    function TickRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultScaleDataKey = "tick";
        return _this;
    }
    TickRenderer.prototype.renderSection = function (section) {
        var _this = this;
        _super.prototype.renderSection.call(this, section);
        var circos = section.parent.circos;
        var towardsCenter = this._getOption("towardsCenter", false);
        var isInner = this._getOption("inner", false);
        var interval = this._getOption("tickInterval", 50000000);
        var $tickEnd = function (r) { return r + (towardsCenter ? -5 : 5); };
        var $textStart = function (r) { return r + (towardsCenter ? -7 : 7); };
        this._ticks = section.appendGroupT(element_1.RadicalLine).options({
            _data: function (d) { return _this.getData(section, d._key, isInner, interval); },
            _r1: function (d) { return d.angle; },
            _r2: function (d) { return d.angle; },
            _y1: function (d) { return _this._r(isInner, section, d._key); },
            _y2: function (d) { return $tickEnd(d.r); },
            stroke: function (_) { return isInner === towardsCenter ? "rgba(255,255,255,.3)" : "rgba(0,0,0,.8)"; },
        });
        this._labels = section.appendGroupT(element_1.Text).options({
            _data: function (d) { return _this.getData(section, d._key, isInner, interval); },
            _$beforeAll: function (d, i, g, h) {
                var radius = $textStart(d.r);
                h.set("r", radius);
                h.set("pos", __1.tool.polar2cart(d.angle, radius));
            },
            _x: function (d, i, g, h) { return h.get("pos")[0]; },
            _y: function (d, i, g, h) { return h.get("pos")[1]; },
            _text: function (d) { return filesize(d.value, { base: 10, symbols: { B: "bp", KB: "K", MB: "M" } }); },
            _anchor: function (d) { return circos.labelAnchor(d.angle, towardsCenter); },
            _rotation: function (d, i, g, h) { return circos.labelRotation.apply(circos, __spreadArrays([d.angle], h.get("pos"))); },
            // visibility: (d, i, g) => i === 0 || i === g.length - 1 ? "visible" : "hidden",
            "font-size": 8,
            fill: function (_) { return isInner === towardsCenter ? "rgba(255,255,255,.3)" : "rgba(0,0,0,.8)"; },
        });
        this.assignGOptions({ dot: "_points", line: "_lines" });
    };
    TickRenderer.prototype.getData = function (section, key, isInner, interval) {
        var _this = this;
        var xScale = section.parent.circos.xScaleForChr(key);
        var _a = xScale.domain(), start = _a[0], end = _a[1];
        var ticks = [];
        var last = start;
        while (last < end) {
            ticks.push(last);
            last += interval;
        }
        ticks.push(end);
        return ticks.map(function (value) { return ({
            _key: key,
            angle: xScale(value),
            value: value,
            r: _this._r(isInner, section, key),
        }); });
    };
    return TickRenderer;
}(base_1.Renderer));
exports.TickRenderer = TickRenderer;
//# sourceMappingURL=tick.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/tick.js
// module id = 1188
// module chunks = 0 1